<template>
  <teleport to="#base-loader">
    <div v-if="userStore.baseLoading" class="animation-loader">
      <BaseSvg :src="ActiveLogo" />
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { ActiveLogo } from '@/assets/icons';
import { useUserStore } from '@/stores';
import { BaseSvg } from '@/components/Base';
const userStore = useUserStore();
</script>

<style scoped lang="scss">
.animation-loader{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  left: 0;
  user-select: none;
  pointer-events: none;
  background-color: rgba($disabled-200,0.4);
}
</style>